import { render, staticRenderFns } from "./QnaActions.vue?vue&type=template&id=7bd45995&"
import script from "./QnaActions.vue?vue&type=script&lang=js&"
export * from "./QnaActions.vue?vue&type=script&lang=js&"
import style0 from "./QnaActions.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports